import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { IncludeContent } from 'bricks';
import { Heading, PopupStateless } from 'components';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { SharedZoneProductGoodsContext } from 'store/SharedZone/blocks/contexts';
import * as SharedZoneGoods from 'store/SharedZone/blocks/goods/selectors';
import { SharedZoneBlocks, SharedZoneInfographic } from 'store/SharedZone/blocks/selectors';

import { GoodsDayProduct, InfoGraphicItem } from './components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class InfoGraphicLayout extends React.PureComponent {
  state = {
    isPopupOpen: false,
    popupContent: undefined,
  };

  openPopup = (markup) =>
    this.setState({
      isPopupOpen: true,
      popupContent: markup,
    });

  closePopup = () =>
    this.setState({
      isPopupOpen: false,
      popupContent: undefined,
    });

  render() {
    const {
      description,
      descriptionList,
      goodsDayIds,
      hasGoods,
      heading,
      headlineTagName,
      isMobile,
      list,
      listItemsHasMarkup,
    } = this.props;
    const { isPopupOpen, popupContent } = this.state;
    return (
      <div className={cx('wrapper', isMobile ? 'mobile' : null)}>
        <div
          className={cx('component', isMobile ? 'mobile' : null, hasGoods && !isMobile && 'col')}
        >
          {heading ?
            <Heading className={cx('headline')} level={2} tagName={headlineTagName}>
              {heading}
            </Heading>
          : null}
          {description && <p className={cx('description')}>{description}</p>}
          {descriptionList &&
            descriptionList.length !== 0 &&
            descriptionList.map((descriptionLine, ind) => (
              <p className={cx('description')} key={`description_line_${+ind}`}>
                {descriptionLine}
              </p>
            ))}
          <div className={cx('items', listItemsHasMarkup && isMobile && 'withMarkup')}>
            {list.map(
              ({ href, imageUrl, isOnPCHref, popupMarkup, title, verticalAlign }, index) => (
                <InfoGraphicItem
                  {...{
                    hasMarkup: listItemsHasMarkup && !!popupMarkup,
                    href,
                    imageUrl,
                    isMobile,
                    isOnPCHref,
                    title,
                    verticalAlign,
                    ...(listItemsHasMarkup ?
                      {
                        onClick: () => {
                          this.openPopup(popupMarkup);
                        },
                        popupMarkup,
                      }
                    : null),
                  }}
                  key={+index}
                />
              ),
            )}
          </div>
          {!isMobile && listItemsHasMarkup && (
            <PopupStateless onClose={this.closePopup} opened={isPopupOpen}>
              <IncludeContent className={cx('popupContent')} htmlContent={popupContent} />
            </PopupStateless>
          )}
        </div>
        {hasGoods && (
          <div className={cx('goods', isMobile ? 'mobile' : null)}>
            {goodsDayIds.map((goodsId) => (
              <SharedZoneProductGoodsContext.Provider key={goodsId} value={goodsId}>
                <GoodsDayProduct isMobile={isMobile} />
              </SharedZoneProductGoodsContext.Provider>
            ))}
          </div>
        )}
      </div>
    );
  }
}

InfoGraphicLayout.propTypes = {
  description: PropTypes.string,
  /* Array of lines of description */
  descriptionList: PropTypes.arrayOf(PropTypes.string),
  goodsDayIds: PropTypes.array,
  hasGoods: PropTypes.bool,
  heading: PropTypes.string,
  headlineTagName: PropTypes.string,
  isMobile: PropTypes.bool,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      imageUrl: PropTypes.string,
      isOnPCHref: PropTypes.bool,
      popupMarkup: PropTypes.any,
      title: PropTypes.string,
      verticalAlign: PropTypes.bool,
    }),
  ),
  listItemsHasMarkup: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  description: SharedZoneBlocks.getDescription(state),
  descriptionList: SharedZoneBlocks.getDescriptionList(state),
  goodsDayIds: SharedZoneGoods.getIds(state),
  hasGoods: SharedZoneGoods.getGoodsLength(state),
  heading: SharedZoneBlocks.getHeadline(state),
  headlineTagName: SharedZoneBlocks.getHeadlineTagName(state),
  isMobile: isScreenBelow800(state),
  list: SharedZoneInfographic.getList(state),
  listItemsHasMarkup: SharedZoneInfographic.getListHasMarkup(state),
});

const InfoGraphic = SharedZoneBlocks.connect(mapStateToProps)(InfoGraphicLayout);

export default InfoGraphic;
